// @ts-nocheck

export const createActionName = (eventName: string) => {
	return `advertising-action/${eventName}`;
};
export const createUrl = (selectedTab: string) => {
	return `/advertising?selectedTab=${selectedTab}`;
};
